import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=476fc188&scoped=true"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"
import style0 from "./FileInput.vue?vue&type=style&index=0&id=476fc188&prod&lang=scss"
import style1 from "./FileInput.vue?vue&type=style&index=1&id=476fc188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476fc188",
  null
  
)

export default component.exports